import { render } from "./ListeDemandeCommande.vue?vue&type=template&id=0abb2867&ts=true"
import script from "./ListeDemandeCommande.vue?vue&type=script&lang=ts"
export * from "./ListeDemandeCommande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__